// import * as lottie from 'lottie-web';

// export function init($name = '') {
//     let elem = $($name);
//
//     if (!elem.length) {
//         return;
//     }
//
//     let animations = {};
//
//     elem.each(function() {
//         const that = $(this);
//
//         const params = {
//             container: document.getElementById(that.attr('id')),
//             renderer: 'svg',
//             loop: false,
//             autoplay: false,
//             path: that.data('path')
//         };
//
//         animations[that.attr('id')] = lottie.loadAnimation(params);
//
//         const parent = that.parents($name + '-parent');
//
//         that.find('svg').addClass('remove-css');
//
//         parent.bind('mouseenter', function() {
//             that.find('svg').addClass('remove-css');
//
//             animations[that.attr('id')].goToAndPlay(0);
//         });
//
//         parent.bind('mouseleave', function() {
//             animations[that.attr('id')].pause();
//         });
//     });
// }

export function gif($name = '') {
    let elem = $($name);

    if (!elem.length) {
        return;
    }

    elem.each(function() {
        const that = $(this);
        const gif = that.find($name + '-img').data('second-src');
        const blank = that.find($name + '-img').attr('src');

        let imgPreload = new Image();

        $(imgPreload).on('load', function() {

            that.mouseenter(function() {
                const elem = $(this);
                const xhr = new XMLHttpRequest();

                xhr.open( "GET", gif );
                xhr.responseType = "blob";

                xhr.onload = function() {
                    if ( xhr.status != 200 ) {
                        elem.find($name + '-img').attr('src', gif);
                        return;
                    }

                    const blobUrl = URL.createObjectURL( xhr.response );
                    elem.find($name + '-img').attr('src', blobUrl);

                    setTimeout( function () {
                        URL.revokeObjectURL( blobUrl );
                    }, 0 );
                };

                xhr.send();
            });

            that.mouseleave(function() {
                $(this).find($name + '-img').attr('src', blank);
            });

        }).attr({
            src: gif
        });
    });
}